<app-enfaf-modal
  title="Establece tu contraseña"
  svgIcon="unlock"
  (onClose)="closeModal()"
  (onConfirm)="savePassword()"
  [isLoading]="isSavingPassword"
  buttonConfirmText="Establecer contraseña"
>
  <p> Por tu seguridad, debes establecer tu contraseña ahora </p>

  <div class="profile-section-content">
    <form [formGroup]="passwordForm">
      <div class="password-settings">
        <div class="profile-row">
          <div class="profile-col">
            <enfaf-input color="light" [control]="passwordForm.controls.password" label="Contraseña" name="password"
              placeholder="Tu contraseña" autocomplete="off" errorLabel="Mínimo 6 caracteres"
              type="{{ hidePassword ? 'password' : 'text' }}" [iconSuffix]="passwordIconSuffix"></enfaf-input>

          </div>
          <div class="profile-col">
            <enfaf-input color="light" [control]="passwordForm.controls.repeatPassword" label="Repetir contraseña"
              name="repeatPassword" placeholder="Repite tu contraseña" autocomplete="off"
              [errorLabel]="passwordForm.controls.repeatPassword.hasError('equalsPassword') ? 'Las contraseñas deben ser iguales' : 'Contraseña repetida requerida'"
              type="{{ hideRepeatPassword ? 'password' : 'text' }}"
              [iconSuffix]="repeatPasswordIconSuffix"></enfaf-input>

          </div>
        </div>
      </div>
    </form>
  </div>

</app-enfaf-modal>
